import React from 'react';
import PropTypes from 'prop-types';
import NavLink from './NavLink';
import { NAV_DEPTH } from '../utils/trackEvent';

/**
 * DrilldownLeafLink — renders a single ungrouped leaf link inside a list item.
 *
 * Always sits one level down (it is only ever rendered inside a drilldown body,
 * directly or via DrilldownGroup), so it reports the sub-nav depth to analytics.
 *
 * @param {Object} props
 * @param {NavigationItem} props.item - A navigation item with a real URL
 * @param {() => void} props.onLinkClick - Called when the link is clicked
 */
const DrilldownLeafLink = ({ item, onLinkClick }) => (
	<li>
		<NavLink
			item={item}
			onLinkClick={onLinkClick}
			depth={NAV_DEPTH.SUB_NAV}
		/>
	</li>
);

DrilldownLeafLink.propTypes = {
	item: PropTypes.shape({
		label: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired
	}).isRequired,
	onLinkClick: PropTypes.func.isRequired
};

export default DrilldownLeafLink;
